export default __webpack_public_path__ + "static/media/JobCard1.e19117a0.jpeg";